export default __webpack_public_path__ + "static/media/OP.5de498fa.svg";